import {
    ICreatePatient,
    IPatientFormula,
    CreateEntities,
    DeleteEntities,
    IUpdatetPaymentHistory,
    ICreateUser,
    IUpdateUser,
} from "@/shared/interfaces/patientPage";
import { api } from "./api";
import {
    INewAppointment,
    IUpdateApp,
    IUpdateHasVisited,
} from "@/shared/interfaces/schedulePage";
import { ICreateNewService, IExistService } from "@/shared/interfaces/service";

export async function deleteEntitty(id: string, entity: DeleteEntities) {
    try {
        const response = await api.delete(`${entity}/${id}`, {
            withCredentials: true,
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return { message: "Щось пішло не так" };
        }
    }
}

export async function updateEntity(
    id: string,
    entity: DeleteEntities,
    data:
        | ICreatePatient
        | IUpdateApp
        | IPatientFormula
        | IUpdatetPaymentHistory
        | IUpdateUser
        | IExistService
        | IUpdateHasVisited,
) {
    try {
        const response = await api.patch(`${entity}/${id}`, data, {
            withCredentials: true,
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return { message: "Щось пішло не так" };
        }
    }
}

export async function createEntity(
    entity: CreateEntities,
    data:
        | ICreatePatient
        | IPatientFormula
        | INewAppointment
        | ICreateUser
        | ICreateNewService,
) {
    try {
        const response = await api.post(`${entity}`, data, {
            withCredentials: true,
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return { message: "Щось пішло не так" };
        }
    }
}

export async function uploadPhotosEntity(data: FormData) {
    try {
        const response = await api.post("patients/photos", data, {
            withCredentials: true,
        });
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return { message: "Щось пішло не так" };
        }
    }
}
